
import actions from './actions'
import mutations from './mutations'

let state = {
    all: null,
    count: 0,
    current: null,
    page: 1
}

const ACTIONS = {
    GET: 'archives/get',
    GET_ALL: 'archives/getAll',
    GET_NEXT: 'archives/getNext'
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}

export { ACTIONS as actions }